const searchPaymentForms = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return [
    { value:"01",	label:"Efectivo" },
    { value:"02",	label:"Cheque nominativo" },
    { value:"03",	label:"Transferencia electrónica de fondos" },
    { value:"04",	label:"Tarjeta de crédito" },
    { value:"05",	label:"Monedero electrónico" },
    { value:"06",	label:"Dinero electrónico" },
    { value:"08",	label:"Vales de despensa" },
    { value:"12",	label:"Dación en pago" },
    { value:"13",	label:"Pago por subrogación" },
    { value:"14",	label:"Pago por consignación" },
    { value:"15",	label:"Condonación" },
    { value:"17",	label:"Compensación" },
    { value:"23",	label:"Novación" },
    { value:"24",	label:"Confusión" },
    { value:"25",	label:"Remisión de deuda" },
    { value:"26",	label:"Prescripción o caducidad" },
    { value:"27",	label:"A satisfacción del acreedor" },
    { value:"28",	label:"Tarjeta de débito" },
    { value:"29",	label:"Tarjeta de servicios" },
    { value:"30",	label:"Aplicación de anticipos" },
    { value:"31",	label:"Intermediario pagos" },
    { value:"99",	label:"Por definir" },
  ]
};

const searchPaymentMethods = async (filters: Record<string, any> = {}) => {
    const params = new URLSearchParams(filters as any);
    return [
        { value:"PUE", 	label:"Pago en una sola exhibición (de contado)." },
        { value:"PPD", 	label:"Pago en parcialidades o diferido (total o parcialmente a crédito). Requiere expedir un comprobante de pago cuando se reciba un pago subsecuente." },
    ]
};

const searchCfdiUses = async (filters: Record<string, any> = {}) => {
    const params = new URLSearchParams(filters as any);
    return [
        { value:"G01", label:"Adquisición de mercancías", regimens:[601, 603, 606, 612, 620, 621, 622, 623, 624, 625,626] },
        { value:"G02", label:"Devoluciones, descuentos o bonificaciones", regimens:[601, 603, 606, 612, 620, 621, 622, 623, 624, 625,626] },
        { value:"G03", label:"Gastos en general", regimens:[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
        { value:"I01", label:"Construcciones", regimens:[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
        { value:"I02", label:"Mobiliario y equipo de oficina por inversiones", regimens:[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
        { value:"I03", label:"Equipo de transporte", regimens:[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
        { value:"I04", label:"Equipo de computo y accesorios", regimens:[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
        { value:"I05", label:"Dados, troqueles, moldes, matrices y herramental", regimens:[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
        { value:"I06", label:"Comunicaciones telefónicas", regimens:[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
        { value:"I07", label:"Comunicaciones satelitales", regimens:[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
        { value:"I08", label:"Otra maquinaria y equipo", regimens:[601, 603, 606, 612, 620, 621, 622, 623, 624, 625, 626] },
        { value:"D01", label:"Honorarios médicos, dentales y gastos hospitalarios", regimens:[605, 606, 608, 611, 612, 614, 607, 615, 625] },
        { value:"D02", label:"Gastos médicos por incapacidad o discapacidad", regimens:[605, 606, 608, 611, 612, 614, 607, 615, 625] },
        { value:"D03", label:"Gastos funerales", regimens:[605, 606, 608, 611, 612, 614, 607, 615, 625] },
        { value:"D04", label:"Donativos", regimens:[605, 606, 608, 611, 612, 614, 607, 615, 625] },
        { value:"D05", label:"Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación)", regimens:[605, 606, 608, 611, 612, 614, 607, 615, 625] },
        { value:"D06", label:"Aportaciones voluntarias al SAR", regimens:[605, 606, 608, 611, 612, 614, 607, 615, 625] },
        { value:"D07", label:"Primas por seguros de gastos médicos", regimens:[605, 606, 608, 611, 612, 614, 607, 615, 625] },
        { value:"D08", label:"Gastos de transportación escolar obligatoria", regimens:[605, 606, 608, 611, 612, 614, 607, 615, 625] },
        { value:"D09", label:"Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones", regimens:[605, 606, 608, 611, 612, 614, 607, 615, 625] },
        { value:"D10", label:"Pagos por servicios educativos (colegiaturas)", regimens:[605, 606, 608, 611, 612, 614, 607, 615, 625] },
        { value:"S01", label:"Sin efectos fiscales", regimens:[6601, 603, 605, 606, 608, 610, 611, 612, 614, 616, 620, 621, 622, 623, 624, 607, 615, 625, 626] },
        { value:"CP01", label:"Pagos", regimens:[601, 603, 605, 606, 608, 610, 611, 612, 614, 616, 620, 621, 622, 623, 624, 607, 615, 625, 626] },
        { value:"CN01", label:"Nómina", regimens:[605] },
    ]
};

const searchFiscalRegiments = async (filters: Record<string, any> = {}) => {
    const params = new URLSearchParams(filters as any);
    return [
        { value:"601", label:"General de Ley Personas Morales" },
        { value:"603", label:"Personas Morales con Fines no Lucrativos" },
        { value:"605", label:"Sueldos y Salarios e Ingresos Asimilados a Salarios" },
        { value:"606", label:"Arrendamiento" },
        { value:"608", label:"Demás ingresos" },
        { value:"609", label:"Consolidación" },
        { value:"610", label:"Residentes en el Extranjero sin Establecimiento Permanente en México" },
        { value:"611", label:"Ingresos por Dividendos (socios y accionistas)" },
        { value:"612", label:"Personas Físicas con Actividades Empresariales y Profesionales" },
        { value:"614", label:"Ingresos por intereses" },
        { value:"616", label:"Sin obligaciones fiscales" },
        { value:"620", label:"Sociedades Cooperativas de Producción que optan por diferir sus ingresos" },
        { value:"621", label:"Incorporación Fiscal" },
        { value:"622", label:"Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras" },
        { value:"623", label:"Opcional para Grupos de Sociedades" },
        { value:"624", label:"Coordinados" },
        { value:"628", label:"Hidrocarburos" },
        { value:"607", label:"Régimen de Enajenación o Adquisición de Bienes" },
        { value:"629", label:"De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales" },
        { value:"630", label:"Enajenación de acciones en bolsa de valores" },
        { value:"615", label:"Régimen de los ingresos por obtención de premios" },
        { value:"625", label:"Régimen de las Actividades Empresariales con ingresos a través de Plataformas Tecnológicas" },
        { value:"626", label:"Régimen Simplificado de Confianza" }
    ]
};

const searchProductUnits = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return [
    { name: 'Pieza', key: 'H87' },
    { name: 'Elemento', key: 'EA' },
    { name: 'Unidad de Servicio', key: 'E48' },
    { name: 'Actividad', key: 'ACT' },
    { name: 'Kilogramo', key: 'KGM' },
    { name: 'Trabajo', key: 'E51' },
    { name: 'Tarifa', key: 'A9' },
    { name: 'Metro', key: 'MTR' },
    { name: 'Paquete a granel', key: 'AB' },
    { name: 'Caja base', key: 'BB' },
    { name: 'Kit', key: 'KT' },
    { name: 'Conjunto', key: 'SET' },
    { name: 'Litro', key: 'LTR' },
    { name: 'Caja', key: 'XBX' },
    { name: 'Mes', key: 'MON' },
    { name: 'Hora', key: 'HUR' },
    { name: 'Metro cuadrado', key: 'MTK' },
    { name: 'Equipos', key: '11' },
    { name: 'Miligramo', key: 'MGM' },
    { name: 'Paquete', key: 'XPK' },
    { name: 'Kit (Conjunto de piezas)', key: 'XKI' },
    { name: 'Variedad', key: 'AS' },
    { name: 'Gramo', key: 'GRM' },
    { name: 'Par', key: 'PR' },
    { name: 'Docenas de piezas', key: 'DPC' },
    { name: 'Unidad', key: 'xun' },
    { name: 'Día', key: 'DAY' },
    { name: 'Lote', key: 'XLT' },
    { name: 'Grupos', key: '10' },
    { name: 'Mililitro', key: 'MLT' },
    { name: 'Viaje', key: 'E54' },
  ]
};

const searchTaxes = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return[
    { value: '01', text: 'No objeto de impuesto.'}, 
    { value: '02', text: 'Sí objeto de impuesto.'}, 
    { value: '03', text: 'Sí objeto de impuesto, pero no obligado a desglose.'}, 
    { value: '04', text: 'Sí objeto de impuesto, y no causa impuesto.'}, 
    { value: '05', text: 'Sí objeto de impuesto, IVA crédito PODEBI.'}, 
  ]
}



export default {
  searchPaymentForms,
  searchPaymentMethods,
  searchCfdiUses,
  searchFiscalRegiments,
  searchProductUnits,
  searchTaxes
};
